require('default-passive-events');

import './single-post/scripts/index';
import './single-post/styles/index.scss';

// Blog shared components.
import './blog/scripts/components/menu-blog.js';
import './blog/scripts/components/card-blog.js';
import './blog/scripts/components/blog-events.js';

// Theme shared components.
import './theme/scripts/components/popup-whatsapp/popup-whatsapp.js';
import "./theme/scripts/components/seloRA.js";
import './shared/index.js'
